/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const permissionState = {
    ready: false,
    byGUID: {},
    current: undefined,
    all: [],
    mappings: [],
};
